import { debounce } from "lodash";
import moment from "moment";
import { useCallback } from "react";
import { useDispatch } from "react-redux";
import { updatePendingRequest } from "../redux/actions/pendingRequestAction";
import {
  addPendingRequestsFilter,
  onAcceptPendingRequest,
  onRejectPendingRequest,
  selectPendingRequest,
} from "../redux/actions/types/pendingRequestTypes";
import { useStore } from "./useStore";

const usePendingRequest = () => {
  const dispatch = useDispatch();
  const { authStore, pendingRequestStore } = useStore();

  const searchPendingRequest = (value: string) => {
    if (value) {
      const listPendingRequest = pendingRequestStore.listPendingRequest;
      let filter: any[] = [];
      filter = listPendingRequest.filter(
        (pendingRequest) =>
          pendingRequest.lotNumber
            .toLowerCase()
            .includes(value.toLowerCase()) ||
          pendingRequest.hostName.toLowerCase().includes(value.toLowerCase()) ||
          pendingRequest.hostPhone
            .toLowerCase()
            .includes(value.toLowerCase()) ||
          pendingRequest.guest.toLowerCase().includes(value.toLowerCase())
      );
      dispatch(addPendingRequestsFilter(filter));
    }
  };

  const convertDataTable = (pendingRequests: any[]): any[] => {
    let result: any[] = pendingRequests.map((item) => {
      const hostSearched = searchHost(item);
      return {
        id: item.id,
        lotNumber: item.lotNumber,
        hostName:
          hostSearched.firstname && hostSearched.lastname
            ? getHostFirstName(hostSearched) +
              " " +
              getHostLastName(hostSearched)
            : "Este lote no tiene residentes",
        hostPhone:
          hostSearched !== null
            ? "(" + getHostPhone(hostSearched) + ")"
            : "(Sin información)",
        guest: isDataGuestComplete(item.guests[0])
          ? item.guests[0].firstname + " " + item.guests[0].lastname
          : item.guests[0].phone,
        beginDateOfPass: moment(item.beginDatetime).format("DD-MMM"),
        beginTimeOfPass: moment(item.beginDatetime).format("HH:mm"),
        endTimeOfPass: moment(item.endDatetime).format("HH:mm"),
        comments: item.comments ? item.comments : "sin comentarios",
      };
    });
    return result;
  };

  const refreshDataTable = () => {
    dispatch(addPendingRequestsFilter(pendingRequestStore.listPendingRequest));
  };

  const searchHost = (pendingRequest: any): any => {
    let founded = null;
    authStore.residents.forEach((resident) => {
      if (resident.id === pendingRequest.host) {
        founded = resident;
      }
    });
    if (!founded) {
      authStore.lots.forEach((lot) => {
        if (lot.id === pendingRequest.lot) founded = lot;
      });
    }
    return founded;
  };

  const getHostFirstName = (hostSearched: any): string => {
    return hostSearched ? hostSearched.firstname : "";
  };

  const getHostLastName = (hostSearched: any): string => {
    return hostSearched ? hostSearched.lastname : "";
  };

  const getHostPhone = (hostSearched: any): string => {
    return hostSearched?.phone ? hostSearched.phone : "Sin información";
  };

  const isDataGuestComplete = (guest: any): boolean => {
    return guest.firstname !== "" && guest.lastname !== "" && guest.phone !== ""
      ? true
      : false;
  };

  const onAccept = () => {
    dispatch(
      updatePendingRequest(
        pendingRequestStore.selectPendingRequest.id,
        "accept"
      )
    );
    dispatch(onAcceptPendingRequest(false));
  };

  const onReject = () => {
    dispatch(
      updatePendingRequest(
        pendingRequestStore.selectPendingRequest.id,
        "reject"
      )
    );
    dispatch(onRejectPendingRequest(false));
  };

  const handleClose = () => {
    dispatch(onAcceptPendingRequest(false));
    dispatch(onRejectPendingRequest(false));
    dispatch(selectPendingRequest(null));
  };

  const search = (value: string) => {
    debounceSearch(value);
  };

  const debounceSearch = useCallback(
    debounce((searchVal: string) => {
      searchPendingRequest(searchVal);
    }, 300),
    []
  );

  return {
    onAccept,
    onReject,
    handleClose,
    pendingRequestStore,
    search,
    refreshDataTable,
    convertDataTable,
  };
};

export default usePendingRequest;
